let dd = require('ES/lib/dd');
let Modal = require('ES/widgets/Modal');
let Constants = require('../../../../../../utils/Constants');


module.exports = dd.createClass({
	render(){
		let {service, onClose} = this.props;
		let wiki_url = "https://www.espeakers.com/wiki/Mac_address_book";

		return Modal({
				title: Constants.GRAB_SERVICES[service],
				onClose
			},
			dd.p(null,
				'You can copy contacts from your local Mac Contacts (used to be "Address Book") onto an event without re-typing. ',
				'However, to do it you must connect your Mac Contacts with Google Contacts. ',
				'This article will explain step by step how to do this: '
			),
			dd.a({href: wiki_url, target: "_blank"}, wiki_url)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/contacts/ContactGrabber/MacContactsModal.js